import React, { useState } from 'react'
import type { FC } from 'react'
import { useVisibilityTrigger } from './visibility-trigger.hook.js'
import { LinearProgress } from '../primitives/index.js'
import styles from './visibility-trigger.module.css'

export interface VisibilityTriggerProps {
  onVisible?(): Promise<void>
}

export const VisibilityTrigger: FC<VisibilityTriggerProps> = props => {
  const { onVisible } = props

  const [endRef, setEndRef] = useState<React.ElementRef<'div'> | null>(null)
  const [loading, setLoading] = useState(false)
  const cb = () => {
    if (!onVisible) {
      return
    }
    setLoading(true)
    void onVisible().then(() => setLoading(false))
  }

  useVisibilityTrigger({ el: endRef, cb })

  return (
    <>
      {loading && <LinearProgress />}
      <div className={styles.trigger} ref={setEndRef} />
    </>
  )
}

export default VisibilityTrigger
